import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d1d76c7a = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _2726c0d8 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _718502cb = () => interopDefault(import('../../../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _39da73ba = () => interopDefault(import('../../../pages/confirmation.vue' /* webpackChunkName: "pages/confirmation" */))
const _79bdb59d = () => interopDefault(import('../../../pages/customer-terms.vue' /* webpackChunkName: "pages/customer-terms" */))
const _58d7f968 = () => interopDefault(import('../../../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _d11a01a2 = () => interopDefault(import('../../../pages/join.vue' /* webpackChunkName: "pages/join" */))
const _10863eb4 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _c35d3f16 = () => interopDefault(import('../../../pages/modern-slavery.vue' /* webpackChunkName: "pages/modern-slavery" */))
const _e8398086 = () => interopDefault(import('../../../pages/organisation-sign-up.vue' /* webpackChunkName: "pages/organisation-sign-up" */))
const _b0554058 = () => interopDefault(import('../../../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _7b078ae5 = () => interopDefault(import('../../../pages/premium/index.vue' /* webpackChunkName: "pages/premium/index" */))
const _2860e25c = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _0bf029c6 = () => interopDefault(import('../../../pages/review.vue' /* webpackChunkName: "pages/review" */))
const _40b3b16d = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _721e0236 = () => interopDefault(import('../../../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _77af81af = () => interopDefault(import('../../../pages/store/index.vue' /* webpackChunkName: "pages/store/index" */))
const _a6239ce4 = () => interopDefault(import('../../../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _e90f17c0 = () => interopDefault(import('../../../pages/website-terms.vue' /* webpackChunkName: "pages/website-terms" */))
const _6c20946b = () => interopDefault(import('../../../pages/account/details.vue' /* webpackChunkName: "pages/account/details" */))
const _3a3d3768 = () => interopDefault(import('../../../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _0c265e00 = () => interopDefault(import('../../../pages/account/premium.vue' /* webpackChunkName: "pages/account/premium" */))
const _c5ebe5d4 = () => interopDefault(import('../../../pages/premium/individual.vue' /* webpackChunkName: "pages/premium/individual" */))
const _88a7d162 = () => interopDefault(import('../../../pages/verify/new.vue' /* webpackChunkName: "pages/verify/new" */))
const _46de9b9d = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _89bd7188 = () => interopDefault(import('../../../pages/payment/_id.vue' /* webpackChunkName: "pages/payment/_id" */))
const _27ccdd54 = () => interopDefault(import('../../../pages/premium/_tier.vue' /* webpackChunkName: "pages/premium/_tier" */))
const _0bfd8649 = () => interopDefault(import('../../../pages/reset-password/_id.vue' /* webpackChunkName: "pages/reset-password/_id" */))
const _75f8e067 = () => interopDefault(import('../../../pages/store/_slug.vue' /* webpackChunkName: "pages/store/_slug" */))
const _b0137b2e = () => interopDefault(import('../../../pages/verify/_id.vue' /* webpackChunkName: "pages/verify/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _d1d76c7a,
    name: "404"
  }, {
    path: "/about",
    component: _2726c0d8,
    name: "about"
  }, {
    path: "/checkout",
    component: _718502cb,
    name: "checkout"
  }, {
    path: "/confirmation",
    component: _39da73ba,
    name: "confirmation"
  }, {
    path: "/customer-terms",
    component: _79bdb59d,
    name: "customer-terms"
  }, {
    path: "/forgot",
    component: _58d7f968,
    name: "forgot"
  }, {
    path: "/join",
    component: _d11a01a2,
    name: "join"
  }, {
    path: "/login",
    component: _10863eb4,
    name: "login"
  }, {
    path: "/modern-slavery",
    component: _c35d3f16,
    name: "modern-slavery"
  }, {
    path: "/organisation-sign-up",
    component: _e8398086,
    name: "organisation-sign-up"
  }, {
    path: "/payment",
    component: _b0554058,
    name: "payment"
  }, {
    path: "/premium",
    component: _7b078ae5,
    name: "premium"
  }, {
    path: "/privacy-policy",
    component: _2860e25c,
    name: "privacy-policy"
  }, {
    path: "/review",
    component: _0bf029c6,
    name: "review"
  }, {
    path: "/search",
    component: _40b3b16d,
    name: "search"
  }, {
    path: "/sign-up",
    component: _721e0236,
    name: "sign-up"
  }, {
    path: "/store",
    component: _77af81af,
    name: "store"
  }, {
    path: "/success",
    component: _a6239ce4,
    name: "success"
  }, {
    path: "/website-terms",
    component: _e90f17c0,
    name: "website-terms"
  }, {
    path: "/account/details",
    component: _6c20946b,
    name: "account-details"
  }, {
    path: "/account/orders",
    component: _3a3d3768,
    name: "account-orders"
  }, {
    path: "/account/premium",
    component: _0c265e00,
    name: "account-premium"
  }, {
    path: "/premium/individual",
    component: _c5ebe5d4,
    name: "premium-individual"
  }, {
    path: "/verify/new",
    component: _88a7d162,
    name: "verify-new"
  }, {
    path: "/",
    component: _46de9b9d,
    name: "index"
  }, {
    path: "/payment/:id",
    component: _89bd7188,
    name: "payment-id"
  }, {
    path: "/premium/:tier",
    component: _27ccdd54,
    name: "premium-tier"
  }, {
    path: "/reset-password/:id?",
    component: _0bfd8649,
    name: "reset-password-id"
  }, {
    path: "/store/:slug",
    component: _75f8e067,
    name: "store-slug"
  }, {
    path: "/verify/:id?",
    component: _b0137b2e,
    name: "verify-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
